import { Button } from 'primereact/button';

import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import { CONSTANT } from '../../../../utils/constants';
import { confirmDialog } from 'primereact/confirmdialog';
import RichTextEditor from '../../../../components/Form/RichTextEditor';

function PillsManager({ isOpen, pills, onUppills, loading, onCreate, onClose, handleDelete }) {
  const [type, setType] = useState('');
  const [label, setLabel] = useState('');
  const [details, setDetails] = useState('');

  useEffect(() => {
    if (pills) {
      setType(pills.type);
      setLabel(pills.label);
      setDetails(pills.details);
    } else {
      setType('');
      setLabel(undefined);
      setDetails(undefined);
    }
  }, [pills, onCreate, onUppills]);

  const handleValidate = () => {
    const pillsPayload = {
      type,
      label,
      details
    };
    pills ? onUppills(pillsPayload) : onCreate(pillsPayload);
  };

  const formIsValid = () => {
    return type && label && details?.length;
  };

  const confirmDeletion = (event) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Pill ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(event)
    });
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'delete'}
        label={'Supprimer la pill'}
        className="w-full"
        outlined
        onClick={() => confirmDeletion(pills)}
        severity="danger"
      />
      <Button
        key={'validate'}
        label={`Valider la ${pills ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${pills ? 'Modifier' : 'Ajouter'} une pills`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="page" label={'Page'} required isValid={type}>
            <Dropdown
              value={type}
              options={CONSTANT.quatrebis.pillsType}
              optionLabel="label"
              onChange={(e) => setType(e.value)}
              placeholder="Indiquez la page ou se situera la pills"
              className="grow"
            />
          </FormInput>

          <FormInput
            key="schedule"
            label={'Horaires'}
            helpMessage="Max. 50 caractères"
            required
            isValid={label}>
            <InputText
              id="label"
              value={label}
              maxLength={50}
              placeholder="Veuillez saisir le titre de la pills"
              onChange={(e) => setLabel(e.target.value)}
            />
          </FormInput>
          <FormInput
            key="details"
            label={'Détails'}
            helpMessage="Max. 200 caractères"
            required
            isValid={details?.length}>
            <RichTextEditor
              value={details}
              onChange={(value) => {
                setDetails(value);
              }}
              height={'65vh'}
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default PillsManager;
